/**
 * WordPress Dependencies
 */

import { BlockControls, useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import { createBlock } from '@wordpress/blocks';
import { Button, ToolbarButton, ToolbarGroup } from '@wordpress/components';
import { dispatch, select } from '@wordpress/data';
import { Fragment, useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';

/**
 * External Dependencies
 */
import classNames from 'classnames';

/**
 * Internal Dependencies
 */
import { handleUniqueId } from '../../helper';

// inspector controls
import Inspector from './inspector';

// Dynamic Style
import DynamicStyle from './dynamic-style';

// block edit function
const Edit = props => {
    const { attributes, setAttributes, clientId, isSelected } = props;
    const { uniqueId } = attributes;

    /**
     * Handle Block Unique Id
     */
    useEffect(() => {
        handleUniqueId({ uniqueId, setAttributes, clientId });
    }, []);

    /**
     * Block Props
     */
    const blockProps = useBlockProps({
        className: classNames(uniqueId)
    });

    // Inner blocks
    const innerBlockProps = useInnerBlocksProps(
        {
            className: 'progerssbar-inner-blocks'
        },
        {
            allowedBlocks: ['progressmatify/progressmatifybar'],
            template: [['progressmatify/progressbar'], ['progressmatify/progressbar']],
            renderAppender: false,
            templateLock: false
        }
    );

    // Append Button
    const childBlocks = select('core/block-editor').getBlocks(clientId);
    const appendBtn = () => {
        const newBlock = createBlock('progressmatify/progressbar', {});
        dispatch('core/block-editor').insertBlock(newBlock, childBlocks.length, clientId);
    };

    return (
        <Fragment>
            {isSelected && <Inspector {...props} />}
            <DynamicStyle {...props} />
            <BlockControls>
                <ToolbarGroup>
                    <ToolbarButton icon="insert" title={__('Add Button', 'progressmatify-blocks')} onClick={appendBtn} />
                </ToolbarGroup>
            </BlockControls>

            <div {...blockProps}>
                <div {...innerBlockProps} />
                <Button onClick={appendBtn} style={{ background: 'blue', color: 'white', padding: '12px', margin: '12px' }}>
                    ADD
                </Button>
            </div>
        </Fragment>
    );
};

export default Edit;
